import { setStats } from '../../actions/statsSection';

export const getCustomInitActionsForStatsWidgets = (
  responseData,
  requestParams
) => [setStats(responseData.pageExtraData.detailedStats)];
